/* Smart Home PRO — custom "Sortiraj po" dropdown.
   Vizuelno zamenjuje nativni <select id="SortBy">; izbor prosleđuje
   selectu i okida input/change da Dawn facets.js odradi AJAX. */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-sh-sort]').forEach(function (root) {
      if (root.__shSort) return;
      root.__shSort = true;
      var btn = root.querySelector('.sh-sort__btn');
      var list = root.querySelector('.sh-sort__list');
      var label = root.querySelector('.sh-sort__label');
      if (!btn || !list || !label) return;

      function close() {
        root.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = root.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });

      list.querySelectorAll('.sh-sort__opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var v = opt.getAttribute('data-value');
          list.querySelectorAll('.sh-sort__opt').forEach(function (o) {
            o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
          });
          label.textContent = opt.querySelector('.sh-sort__txt').textContent.trim();
          close();
          var select = document.getElementById('SortBy');
          if (select && select.value !== v) {
            select.value = v;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(init, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
